import { getValue } from '@chegg/commerce-utils';
export var getAddressFromBraintreePayload = function getAddressFromBraintreePayload(defaultCountry, thirdPartyBraintreePayload) {
  return (
    // if data provided by paypal/apple pay validate address flow
    {
      line1: getValue(thirdPartyBraintreePayload, 'details.billingAddress.line1', ''),
      line2: getValue(thirdPartyBraintreePayload, 'details.billingAddress.line2', ''),
      city: getValue(thirdPartyBraintreePayload, 'details.billingAddress.city', ''),
      state: getValue(thirdPartyBraintreePayload, 'details.billingAddress.state', ''),
      zipCode: getValue(thirdPartyBraintreePayload, 'details.billingAddress.postalCode', ''),
      countryISO: getValue(thirdPartyBraintreePayload, 'details.billingAddress.countryCode', defaultCountry)
    }
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/getAddressFromBraintreePayload.js
// module id = 4558
// module chunks = 11